import { Dispatch } from "react"

import { setLs } from "../../utils/localStorage"
import { Action, CheckoutActionKind, State } from "../types/checkoutTypes"
import { removeFromCart } from "."

export const decrementCartItem = (
  cartItemId: string,
  state: State,
  dispatch: Dispatch<Action>
) => {
  const { cartItems } = state
  const existingItem = cartItems.find(item => item.productId === cartItemId)

  if (!existingItem || existingItem.quantity === 0) return

  if (existingItem.quantity === 1) {
    removeFromCart(cartItemId, state, dispatch)
    return
  }

  dispatch({
    type: CheckoutActionKind.DECREMENT_CART_ITEM,
    payload: { cartItemId },
  })
}
